import React from 'react'
import clsx from 'clsx'

import { useSettingsPageStyles } from '../../hooks/settingsPageStylesHook'

import { Box, FormHelperText, FormLabel, Grid } from '@material-ui/core'

import { IOSSwitch } from '../IOSSwitch'

export type CancelUnreserveSwitchProps = {
  value: boolean

  onToggle: VoidFunction
}

export const CancelUnreserveSwitch =
  ({value, onToggle}: CancelUnreserveSwitchProps) => {
    const classes = useSettingsPageStyles()

    return (
      <Grid item xs={9}>
        <Grid container className={clsx(classes.settingsTopic, 'default-border')}>
          <Grid item className={classes.root} xs={12}>
            <Box width={'100%'} display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <FormLabel className={classes.unifiedPricesLabel}>
                  Снятие резерва
                </FormLabel>

                <FormHelperText className={classes.helperText}>
                  При отмене заказа до создания отгрузки резерв по товару снимается, и остаток возвращается на основной
                  склад.<br/>
                  Вы можете отключить эту настройку — тогда резерв не будет сниматься при отмене заказа.
                </FormHelperText>
              </Box>

              <IOSSwitch checked={value} onChange={onToggle}/>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    )
  }
